export default __webpack_public_path__ + "static/media/ferry-station.4738fdad.svg";